











//
// WARNING
// This file is auto-generated by Commands.tst
// Don't try to edit it, your changes will be lost.
// If you nedd to change this file, edit Commands.tst.
//

import { Command } from "@signature/crs-client";
import { endpoint, CommandResult } from '@/modules/crs/crs';


    

    @Command('Automelec.Model-Automelec.Model.Commands.Dashboard.RenameDashboardCommand')
    
    export class RenameDashboardCommand {
        constructor( dashboardId: number, name: string ) {
            
                this.dashboardId = dashboardId;
            
                this.name = name;
            
        }

        
            public dashboardId: number;
        
            public name: string;
        
    }

    export interface IRenameDashboardCommand {
        
            dashboardId: number;
        
            name: string;
        
    }

    export async function renameDashboard( command: RenameDashboardCommand ): Promise<CommandResult<void>>
    export async function renameDashboard( { dashboardId, name }: IRenameDashboardCommand ): Promise<CommandResult<void>>
    export async function renameDashboard( model: any ): Promise<CommandResult<void>> {
        if(model == null) throw new Error("Command cannot be null.");

        var result: CommandResult<void>;

        if(model instanceof RenameDashboardCommand) {
            result = await endpoint.send<CommandResult<void>>(model);
        }
        else {
            result = await endpoint.send<CommandResult<void>>( new RenameDashboardCommand( model['dashboardId'], model['name'] ) );
        }

        return result;
    }

    /**
    * Extraneous types
    */
    export namespace RenameDashboardCommand.ExtraneousTypes {
        

        
    }

